module.exports = __webpack_public_path__ + "img/21.497fa225.webp";